export default "__VITE_ASSET__D84Qhz_N__"